import { useRemotionEnvironment } from "remotion";

// Keep interactive previews light without changing saved settings or exports.
export function useTransitionBlur(blur: number): number {
  const { isPlayer, isStudio, isRendering, isClientSideRendering } =
    useRemotionEnvironment();

  // Rendering takes precedence, including exports made in a browser with a Player.
  if (isRendering || isClientSideRendering) return blur;
  return isPlayer || isStudio ? Math.min(blur * 0.5, 8) : blur;
}

// Only exports pay for the stacked-copy blurs; previews keep a single layer.
export function useStackedBlur(): boolean {
  const { isRendering, isClientSideRendering } = useRemotionEnvironment();
  return isRendering || isClientSideRendering;
}
